
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { CoordinatesPosition, SubRoom } from '@/utils/models';

import SubRoomPresenter from '@/components/room/SubRoomPresenter.vue';
import { getCoordinatesPositionWithoutScale } from '@/utils/functions';

const offset = 4;

@Component({ components: { SubRoomPresenter } })
export default class SubRoomResizer extends Vue {
  @Prop()
  subRoom!: SubRoom;
  @Prop()
  roomSize!: { width: number; height: number };
  @Prop()
  scale!: number;

  @Emit()
  editSubroom(subRoom: SubRoom) {}
  @Emit()
  deleteSubroom(subRoom: SubRoom) {}

  isHover = false;
  startPos: CoordinatesPosition = { x: 0, y: 0 };
  startTopLeft: CoordinatesPosition = { x: 0, y: 0 };
  startBottomRight: CoordinatesPosition = { x: 0, y: 0 };
  get wrapperStyle() {
    const { topLeft, bottomRight } = this.subRoom;
    return {
      top: topLeft.y - offset + 'px',
      left: topLeft.x - offset + 'px',
      width: bottomRight.x - topLeft.x + offset * 2 + 'px',
      height: bottomRight.y - topLeft.y + offset * 2 + 'px',
    };
  }
  mounted() {
    let handlers = Array.from(this.$el.querySelectorAll('.resize-handler'));
    handlers.forEach((el) => {
      let del = el as HTMLDivElement;
      del.addEventListener('pointerdown', this.resizeHanderDown);
      del.addEventListener('pointerup', this.resizeHanderUp);
    });

    let moveel = this.$refs.moveel as HTMLDivElement;
    moveel.addEventListener('pointerdown', this.resizeHanderDown);
    moveel.addEventListener('pointerup', this.resizeHanderUp);
  }
  beforeDestroy() {
    let handlers = Array.from(this.$el.querySelectorAll('.resize-handler'));
    handlers.forEach((el) => {
      let del = el as HTMLDivElement;
      del.removeEventListener('pointerdown', this.resizeHanderDown);
      del.removeEventListener('pointerup', this.resizeHanderUp);
    });
    let moveel = this.$refs.moveel as HTMLDivElement;
    moveel.removeEventListener('pointerdown', this.resizeHanderDown);
    moveel.removeEventListener('pointerup', this.resizeHanderUp);
  }
  resizeHanderDown(ev: PointerEvent) {
    ev.stopPropagation();
    const el = ev.target as HTMLDivElement;
    el.setPointerCapture(ev.pointerId);

    const pos: CoordinatesPosition = { x: ev.x, y: ev.y };
    this.startPos = getCoordinatesPositionWithoutScale(pos, this.scale);
    const { topLeft, bottomRight } = this.subRoom;
    this.startTopLeft = { ...topLeft };
    this.startBottomRight = { ...bottomRight };

    el.addEventListener('pointermove', this.resizeHanderMove);
  }
  resizeHanderMove(ev: PointerEvent) {
    const el = ev.target as HTMLDivElement;
    const pos = { x: ev.x, y: ev.y };
    const unscaledPos = getCoordinatesPositionWithoutScale(pos, this.scale);
    const { topLeft, bottomRight } = this.subRoom;
    if (el.classList.contains('north')) {
      const delta = unscaledPos.y - this.startPos.y;
      topLeft.y = Math.min(Math.max(0, this.startTopLeft.y + delta), this.startBottomRight.y);
    } else if (el.classList.contains('south')) {
      const delta = unscaledPos.y - this.startPos.y;
      bottomRight.y = Math.min(Math.max(this.startTopLeft.y, this.startBottomRight.y + delta), this.roomSize.height);
    } else if (el.classList.contains('west')) {
      const delta = unscaledPos.x - this.startPos.x;
      topLeft.x = Math.min(Math.max(0, this.startTopLeft.x + delta), this.startBottomRight.x);
    } else if (el.classList.contains('east')) {
      const delta = unscaledPos.x - this.startPos.x;
      bottomRight.x = Math.min(Math.max(this.startTopLeft.x, this.startBottomRight.x + delta), this.roomSize.width);
    } else if (el.classList.contains('resizer-wrapper')) {
      let deltaX = unscaledPos.x - this.startPos.x;
      let deltaY = unscaledPos.y - this.startPos.y;
      if (this.startTopLeft.x + deltaX < 0) {
        deltaX = -this.startTopLeft.x;
      } else if (this.startBottomRight.x + deltaX > this.roomSize.width) {
        deltaX = this.roomSize.width - this.startBottomRight.x;
      }
      if (this.startTopLeft.y + deltaY < 0) {
        deltaY = -this.startTopLeft.y;
      } else if (this.startBottomRight.y + deltaY > this.roomSize.height) {
        deltaY = this.roomSize.height - this.startBottomRight.y;
      }
      topLeft.x = this.startTopLeft.x + deltaX;
      topLeft.y = this.startTopLeft.y + deltaY;
      bottomRight.x = this.startBottomRight.x + deltaX;
      bottomRight.y = this.startBottomRight.y + deltaY;
    }
  }
  resizeHanderUp(ev: PointerEvent) {
    const el = ev.target as HTMLDivElement;
    el.releasePointerCapture(ev.pointerId);
    el.removeEventListener('pointermove', this.resizeHanderMove);
  }
}
